import React from 'react';
import { Link } from 'react-router-dom';
import TableLoader from './TableLoader';

const PlanosTable = ({ 
  planos, 
  loading
}) => {
  if (loading) {
    return <TableLoader />;
  }

  return (
    <div className="table-responsive">
      <table className="table align-items-center mb-0">
        <thead>
          <tr>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nome</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Tipo</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ações</th>
          </tr>
        </thead>
        <tbody>
          {planos.map((plano) => (
            <tr key={plano.id}>
              <td className="text-xs mb-0">{plano.name}</td>
              <td className="text-xs mb-0">
                <span className={`badge ${plano.planTypeId === 0 ? 'bg-info' : 'bg-primary'}`}>
                  {plano.planTypeId === 0 ? 'Mensal' : 'Horas'}
                </span>
              </td>
              <td className="text-xs font-weight-bold mb-0">
                <Link to={`/Planos/Editar/${plano.id}`} title="Editar" className="me-3">
                  <i className="bi bi-pencil-square text-primary"></i>
                </Link>
                <Link to={`/Planos/Excluir/${plano.id}`} title="Excluir">
                  <i className="bi bi-trash text-danger"></i>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PlanosTable; 